import React from "react";
import Head from "next/head";
import { Box } from "@catchoftheday/cg-components";
import { withHost } from "@catchoftheday/common-vendors";
import { Footer, Header } from "@catchoftheday/header";
import { ThemeProvider } from "@catchoftheday/theme";
import { cleanHostName } from "@catchoftheday/utilities";
import { PrivacyContent } from "@privacy-app/components";
import { jsx as ___EmotionJSX } from "@emotion/react";

var PrivacyPage = function PrivacyPage(_ref) {
  var host = _ref.host,
      query = _ref.query;
  var bare = (query === null || query === void 0 ? void 0 : query.skin) === "bare";
  var cleanedHost = cleanHostName(host); // Prevent HTML comments being injected into the title tag; see: https://github.com/vercel/next.js/issues/35870#issuecomment-1087516255

  var title = "".concat(host ? "".concat(cleanedHost, " | ") : null, "Privacy Policy");
  return ___EmotionJSX(ThemeProvider, null, ___EmotionJSX(Head, null, ___EmotionJSX("title", null, title)), bare ? null : ___EmotionJSX(Header, {
    host: host
  }), ___EmotionJSX(Box, {
    bg: "#FAFAFA"
  }, ___EmotionJSX(Box, {
    maxWidth: "1340px",
    margin: "auto"
  }, ___EmotionJSX(PrivacyContent, null))), bare ? null : ___EmotionJSX(Footer, null));
};

PrivacyPage.getInitialProps = function (context) {
  return {
    query: context.query
  };
};

export default withHost(PrivacyPage);